//#region DevExtreme Imports

import DevExpress from "devextreme"
import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'

//#endregion

import { Api } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { i18n } from './../i18n/common.i18n'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { Enums } from '../../../models/common/enums';
import { ColumnInfo } from '../../../models/custom/column-info';
import { IOpObject } from '../../../models/util/interfaces';

//#region Asset Imports

import './grid-button.scss'
import * as TEMPLATE from './grid-button.tpl.html'

//#endregion

export interface GridButtonBridge {
    dataRequest(request): ng.IPromise<any>
    columnRequest(): ng.IPromise<any>
    onSelect(e): void
    enabled: boolean
    name: string

    idReferenceType: Enums.ReferenceType
    getDataSourceMethod?: (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => JQueryPromise<{ objects: IOpObject[], totalCount: number, error: { code: any, msg: string } }>
}

interface GridButtonScope extends ng.IScope {
    popoverOptions: DevExpress.ui.dxPopoverOptions
    popoverVisible: boolean
    togglePopover(): void

    popoverGridOptions: GridOptions
    popoverGrid: DevExpress.ui.dxDataGrid

    buttonOptions: DevExpress.ui.dxButtonOptions
    buttonDisabled: boolean

    serialNumber: number
    bridge: GridButtonBridge
}

export class GridButtonDirective implements ng.IDirective {
    constructor() {

    }

    scope = {
        'bridge': '=bridge'
    }
    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'api', 'logger', ($scope: GridButtonScope, $q: ng.IQService, $timeout: ng.ITimeoutService, api: Api, logger: LoggerService) => {
        $scope.popoverVisible = false
        $scope.popoverOptions = {
            width: 600,
            height: 500,
            target: '#popover_' + $scope.$id,
            bindingOptions: {
                visible: 'popoverVisible'
            },
            onHiding: () => {
                $scope.popoverVisible = false
            }
        }

        $scope.togglePopover = () => {
            $scope.popoverVisible = !$scope.popoverVisible
        }

        $scope.bridge.columnRequest().then(defaultColumns => {
            const opts: GridOptions = {
                name: null,
                type: GridTypes.PAGINATED_SMALL,
                buttonsOptions: {
                    enabled: false,
                },
                columnAutoWidth: true,
                addCustomFilters: true,
                columnsDictionary: defaultColumns,
                onRowDoubleClick: e => {
                    $scope.bridge.onSelect(e)
                    $scope.popoverGrid.clearSelection()
                    $scope.togglePopover()
                },
                onInitialized: (e) => {
                    $scope.popoverGrid = e.component
                },
                onDataReady: () => {
                    $scope['showGrid'] = true
                    $timeout(() => {
                        $scope.popoverGrid.updateDimensions()
                    }, 0)
                },
                selection: { mode: 'single' },
                allowColumnReordering: false
            }

            if ($scope.bridge.getDataSourceMethod && $scope.bridge.idReferenceType) {
                opts.getDataSourceMethod = $scope.bridge.getDataSourceMethod
                opts.idReferenceType = $scope.bridge.idReferenceType
            } else {
                opts.request = request => {
                    return $scope.bridge.dataRequest(request)
                }
            }

            $scope.popoverGridOptions = opts
        })

        $scope.buttonDisabled = true
        $scope.$watch(() => {
            return !$scope.bridge.enabled
        }, (value: boolean) => {
            $scope.buttonDisabled = value
        })
        $scope.buttonOptions = {
            activeStateEnabled: false,
            text: i18n("Common", "SelectDevice"),
            onClick: () => {
                $scope.togglePopover()
            },
            bindingOptions: {
                disabled: 'buttonDisabled'
            }
        }
    }]

    template = TEMPLATE
    replace = true
}